import debounce from './Debounce.js';

const SearchBar = (props) => {
  const { handleSearchValue } = props;

  const handleSearchInput = (e) => {
    e.preventDefault();
    const targetValue = e.target.value;
    console.log(targetValue);
    handleSearchValue(targetValue);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const searchValue = e.target[0].value.trim();
    handleSearchValue(searchValue);
  };

  const debounceOnChange = debounce(handleSearchInput, 1000);

  return (
    <form id='search-bar' onSubmit={handleSubmit}>
      <label htmlFor='search-input'>
        <span className='visually-hidden'>Search input</span>
      </label>
      <input
        type='text'
        id='search-input'
        placeholder='Search...'
        onChange={(e) => debounceOnChange(e)}
      />
    </form>
  );
};
export default SearchBar;
